<template>
    <div class="content-wrapper">
        <section class="content-header">
            <h1>
                {{ $t('edit') }} {{ $t('api.account.account') }}
                <template v-if="isLoaded && account.name"> - {{ account.name }} </template>

                <div
                    v-if="isLoaded"
                    class="pull-right"
                >
                    <router-link
                        v-if="account.name"
                        :to="{
                            name: 'apis.accounts.show',
                            params: { id: accountId },
                        }"
                        class="btn btn-sm btn-primary"
                    >
                        <span class="sr-only">{{ $t('api.account.backToAccount') }}</span>
                        <span class="hidden-xs">{{ $t('api.account.backToAccount') }}</span>
                        <span class="visible-xs">
                            <i class="fa fa-arrow-left"></i>
                        </span>
                    </router-link>

                    <router-link
                        v-else
                        :to="{ name: 'apis.accounts.list' }"
                        class="btn btn-sm btn-default"
                    >
                        <span class="sr-only">{{ $t('api.account.accountsList') }}</span>
                        <span class="hidden-xs">{{ $t('api.account.accountsList') }}</span>
                        <span class="visible-xs">
                            <i class="fa fa-list-ul"></i>
                        </span>
                    </router-link>
                </div>
            </h1>
        </section>

        <section class="content">
            <Alerts />

            <div class="row">
                <div class="col-xs-12">
                    <div class="box box-primary">
                        <div
                            v-if="!isLoaded"
                            class="box-body"
                        >
                            <img
                                class="table-row-preloader"
                                rel="preload"
                                src="/img/table-row-preloader.gif"
                            />
                        </div>

                        <ApisAccountsForm
                            v-show="isLoaded"
                            :accountId="accountId"
                            @loaded="onLoaded"
                        />
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import ApisAccountsForm from '@/components/apis/accounts/ApisAccountsForm.vue';

export default {
    components: {
        ApisAccountsForm,
    },

    data() {
        return {
            isLoaded: false,
            accountId: Number(this.$route.params.id),
            account: {},
        };
    },

    computed: {
        headTitle() {
            return this.account.name && `${this.$t('api.account.account')} ${this.account.name} ${this.$t('edit')}`;
        },
    },

    methods: {
        onLoaded(account) {
            this.account = account;
            this.isLoaded = true;
        },
    },
};
</script>
